import React, { useState, useRef, useEffect } from 'react';
import { EyeIcon, CheckCircleIcon } from '@heroicons/react/24/solid';

const CustomDropdown = ({
  currentStatus,
  onSelectStatus,
}: {
  currentStatus: any;
  onSelectStatus: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef(null);

  const statuses = [
    {
      label: 'Unread',
      value: '0',
      icon: <div className="bg-violet w-2 h-2 rounded-full m-auto" />,
    },
    {
      label: 'Resolved',
      value: '2',
      icon: <CheckCircleIcon className="text-green-400 w-5 h-5" />,
    },
  ];

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (status: any) => {
    onSelectStatus(status);
    setIsOpen(false);
  };

  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentStatusLabel =
    statuses.find((status) => status.value === currentStatus)?.label ||
    'Set Status';

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        ref={buttonRef}
        className="w-36 border py-1 rounded-2xl text-white bg-white bg-opacity-10 px-4 flex items-center justify-between"
        onClick={toggleDropdown}
      >
        {currentStatusLabel}
        <svg
          className={`w-4 h-4 ml-2 transition-transform transform ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="absolute bottom-full mb-2 w-full rounded-2xl bg-white bg-opacity-10 backdrop-blur-md shadow-lg z-10 overflow-hidden">
          {statuses.map((status) => (
            <div
              key={status.value}
              className="px-4 py-2 flex items-center cursor-pointer hover:bg-white hover:bg-opacity-20"
              onClick={() => handleSelect(status.value)}
            >
              <div className="mr-2 w-5">{status.icon}</div>
              <span className="text-white">{status.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
